<template>
  <div class="q-ma-sm q-gutter-y-sm">
    <div class="q-pa-md bg-white rounded-borders">
      <div class="row q-gutter-md items-start wrap">
        <q-input
          v-model="codBarras"
          label="Código Barras"
          square
          class="col-3"
          @keyup="sanitizeInput('codBarras')"
          @keyup.enter="buscar"
        ></q-input>

        <q-input
          v-model="codProduto"
          label="Código Produto"
          square
          class="col-3"
          @keyup="sanitizeInput('codProduto')"
          @keyup.enter="buscar"
        ></q-input>

        <q-input
          v-model="nrEmbalagem"
          label="Nrº Embalagem"
          square
          @input="sanitizeInput('nrEmbalagem')"
          @keyup.enter="buscar"
        ></q-input>

        <q-btn
          color="primary"
          label="Buscar"
          @click="buscar"
          class="col-2"
        ></q-btn>
      </div>

      <div class="row q-gutter-md items-start wrap q-mt-md">
        <q-select
          v-model="modeloSelecionado"
          :options="modelosEtiquetas"
          option-value="value"
          option-label="label"
          label="Modelos de Etiqueta"
          class="col-4"
        ></q-select>

        <q-input
          v-if="buscaRealizada && nrEmbalagem && nrEmbalagem.length > 0"
          v-model.number="qtdRepetir"
          label="Nº Repetições"
          square
          type="number"
          min="1"
          @keydown="handleKeyDown"
          @blur="sanitizeqtdRepetir"
        />

        <q-btn
          color="secondary"
          label="Imprimir"
          @click="imprimir"
          class="col-2"
        />
      </div>

      <q-table
        :rows="dados"
        :columns="colunas"
        row-key="codPro"
        class="q-mt-md custom-table"
        flat
        :hide-pagination="true"
        :rows-per-page-options="[0]"
        :hide-header="!dados.length"
      >
        <template v-slot:header>
          <q-tr>
            <q-th v-for="col in colunas" :key="col.name" class="custom-header">
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props">
            <q-td>{{ props.row.codPro }}</q-td>
            <q-td>{{ props.row.nomFam }}</q-td>
            <q-td>{{ props.row.desPro }}</q-td>
          </q-tr>
          <q-tr>
            <q-td colspan="3" class="q-pa-none">
              <q-table
                :rows="props.row.derivacoes"
                :columns="subColumns"
                class="custom-subtable"
                flat
                :hide-pagination="true"
                :rows-per-page-options="[0]"
              >
                <template v-slot:header>
                  <q-tr class="bg-light">
                    <q-th class="custom-header">Código Produto</q-th>
                    <q-th class="custom-header">Código Barras</q-th>
                    <q-th class="custom-header">Derivação</q-th>
                    <q-th class="custom-header">Qtd</q-th>
                  </q-tr>
                </template>
                <template v-slot:body="subProps">
                  <q-tr :props="subProps">
                    <q-td>{{ subProps.row.codPro }}</q-td>
                    <q-td>{{ subProps.row.codBa2 }}</q-td>
                    <q-td>{{ subProps.row.codDer }}</q-td>
                    <q-td>
                      <q-input
                        v-model.number="subProps.row.qtdPro"
                        type="number"
                        dense
                        outlined
                      ></q-input>
                    </q-td>
                  </q-tr>
                </template>
              </q-table>
            </q-td>
          </q-tr>
        </template>
      </q-table>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useQuasar } from 'quasar';
import EtiquetasServices from '@/services/etiquetas';
import ParametrosServices from '@/services/parametros';
import ImpressaoServices from '@/services/driver_impressao';


export default {
  name: "PesquisaProdutos",
  setup() {
    const $q = useQuasar();
    const codBarras = ref('');
    const codProduto = ref('');
    const nrEmbalagem = ref('');
    const dados = ref([]);
    const modelosEtiquetas = ref([]);
    const modeloSelecionado = ref(null);
    const idModeloImpressora = ref(null);
    const nomeModeloImpressora = ref('');
    const nomeComputadorImpressora = ref(null);
    const qtdRepetir = ref(1);
    const buscaRealizada = ref(false);


    
    const sanitizeqtdRepetir = () => {
    const num = parseInt(qtdRepetir.value, 10);
    if (isNaN(num) || num < 1) {
      qtdRepetir.value = 1;
    } else {
      qtdRepetir.value = num;
    }
    };

    const handleKeyDown = (event) => {
      const invalidKeys = ['-', '+', 'e', 'E'];

      if (
        invalidKeys.includes(event.key) ||
        (event.key.length === 1 && isNaN(event.key))
      ) {
        event.preventDefault();
      }
    };


    const colunas = [
      { name: 'codPro', label: 'Código Produto', align: 'left', field: 'codPro', sortable: true },
      { name: 'nomFam', label: 'Nome Família', align: 'left', field: 'nomFam', sortable: true },
      { name: 'desPro', label: 'Descrição Produto', align: 'left', field: 'desPro', sortable: true }
    ];

    const subColumns = [
      { name: 'codPro', label: 'Código Produto', align: 'left', field: 'codPro' },
      { name: 'codBa2', label: 'Código Barras', align: 'left', field: 'codBa2' },
      { name: 'codDer', label: 'Derivação', align: 'left', field: 'codDer' },
      { name: 'qtdPro', label: 'Qtd', align: 'left', field: 'qtdPro' }
    ];

    const loadModelosEtiquetas = async () => {
      try {
        const modelos = await EtiquetasServices.listarModelosEtiquetas();
        modelosEtiquetas.value = modelos.map(modelo => ({
          label: modelo.modelo,
          value: modelo.id
        }));
      } catch (error) {
        exibirMensagem("Erro ao carregar modelos de etiquetas: " + error);
      }
    };


    const loadConfiguracaoLoja = async () => {
      try {
        let hostname = await ImpressaoServices.buscarHostname();
        const configuracao = await ParametrosServices.listarConfiguracaoLoja(hostname["nome_computador"]);
        if (configuracao == -1){
          console.log("loja n selecionada")
        }
        else {
          idModeloImpressora.value = configuracao[0].id_impressora;
          nomeModeloImpressora.value = configuracao[0].nome_impressora;
          nomeComputadorImpressora.value = configuracao[0].ip_server_impressao;
        }
      } catch (error) {
        exibirMensagem("Revise as configurações de impressão: " + error);
      }
    };
    
    onMounted(() => {
      loadModelosEtiquetas();
      loadConfiguracaoLoja();
    });

    const sanitizeInput = (field) => {
      if (field === 'codBarras') {
        codBarras.value = codBarras.value.replace(/[^0-9]+/g, '');
      } else if (field === 'codProduto') {
        codProduto.value = codProduto.value.replace(/[^0-9]+/g, '');
      } else if (field === 'nrEmbalagem') {
        nrEmbalagem.value = nrEmbalagem.value.replace(/[^0-9]+/g, '');
      }
      else if (field === 'qtdRepetir') {
        qtdRepetir.value = Math.max(1, parseInt(qtdRepetir.value || 1));
      }
    };

    const exibirMensagem = (mensagem, tipo = 'negative') => {
      $q.notify({
        message: mensagem,
        color: tipo,
        position: 'top',
        timeout: 3000
      });
    };

    const buscar = async () => {
      if (!codBarras.value && !codProduto.value && !nrEmbalagem.value) {
        exibirMensagem("Por favor, preencha pelo menos um dos campos para busca.");
        return;
      }

      $q.loading.show();

      try {
        if (nrEmbalagem.value) {
          const response = await EtiquetasServices.buscarEmbalagemEtiqueta({ num_embalagem: nrEmbalagem.value });
          if (response.embalagens && response.embalagens.length > 0) {
            const produtosAgrupados = response.embalagens.reduce((acc, embalagem) => {
              if (!acc[embalagem.codPro]) {
                acc[embalagem.codPro] = {
                  codPro: embalagem.codPro,
                  nomFam: embalagem.nomFam,
                  desPro: embalagem.desPro,
                  derivacoes: []
                };
              }
              acc[embalagem.codPro].derivacoes.push({
                codPro: embalagem.codPro,
                codDer: embalagem.codDer,
                qtdPro: embalagem.qtdPro,
                maiPvn: embalagem.maiPvn,
                preVen: embalagem.preVen,
                codBa2: embalagem.codBa2,
                desCor: embalagem.desCor,
                desFam: embalagem.nomFam,
                desPro: embalagem.desPro,
                intDer: embalagem.intDer,
                fxaPre: embalagem.fxaPre,
                codPai: embalagem.codPai,
                desCcp: embalagem.desCcp,
                desExp: embalagem.desExp,
                desNoo: embalagem.desNoo,
                desTem: embalagem.desTem,
                pirPro: embalagem.pirPro,
                ultDat: embalagem.ultDat,
                qrcode: embalagem.qrcode
              });
              return acc;
            }, {});
            dados.value = Object.values(produtosAgrupados);
            qtdRepetir.value = 1;
            buscaRealizada.value = true;
          } else {
            dados.value = [];
            exibirMensagem("Nenhuma embalagem encontrada.");
          }
        } else if (codBarras.value || codProduto.value) {
          const params = {};
          if (codBarras.value) {
            params.cod_barras = codBarras.value;
          }
          if (codProduto.value) {
            params.cod_produto = codProduto.value;
          }
          const response = await EtiquetasServices.buscarProdutoEtiqueta(params);
          if (response.produtos && response.produtos.length > 0) {
            dados.value = response.produtos.map(produto => {
              let derivacoes = [];
    
              if (Array.isArray(produto.derivacoes)) {
                derivacoes = produto.derivacoes;
              } else if (produto.derivacoes) {
                derivacoes = [produto.derivacoes];
              }

              const caracteristicas = produto.caracteristicas || [];
              const caracteristica = caracteristicas.filter(caracteristica => caracteristica.codCte === "022");

              return {
                codPro: produto.codPro,
                nomFam: produto.desFam,
                desPro: produto.desPro,
                derivacoes: derivacoes.map(derivacao => ({
                  maiPvn: produto.maiPvn,
                  preVen: produto.preVen,
                  codBa2: derivacao.codBa2,
                  codPro: produto.codPro,
                  codDer: derivacao.codDer,
                  desCor: produto.desCor,
                  desFam: produto.desFam,
                  desPro: produto.desPro,
                  intDer: produto.intDer,
                  fxaPre: produto.fxaPre,
                  codPai: produto.codPai,
                  desCcp: caracteristica.length > 0 ? caracteristica[0].desCcp : "",
                  qtdPro: produto.qtdPro,
                  desExp: produto.desExp,
                  desNoo: produto.desNoo,
                  desTem: produto.desTem,
                  pirPro: produto.pirPro,
                  ultDat: produto.ultDat,
                  qrcode: produto.qrcode
                }))
              };
            });
          } else {
            dados.value = [];
            exibirMensagem("Nenhum produto encontrado.");
          }
        }
      } catch (error) {
        exibirMensagem("A pesquisa informada não retornou dados.");
        console.log(error);
      } finally {
        $q.loading.hide();
      }
    };

    const imprimir = async () => {
      const selectedRowsData = dados.value.flatMap(item => item.derivacoes.filter(deriv => deriv.qtdPro > 0));

      if (selectedRowsData.length === 0) {
        exibirMensagem("Por favor, defina a quantidade para ao menos um produto.");
        return;
      }

      if (!modeloSelecionado.value) {
        exibirMensagem("Por favor, selecione um modelo de etiqueta.");
        return;
      }

      if (!idModeloImpressora.value) {
        exibirMensagem("Modelo de impressora não configurado. Por favor, verifique as configurações da loja.");
        return;
      }

      $q.loading.show();
      try {
        const dadosParaImpressao = selectedRowsData.map(item => ({
          "codigo_produto": item.codPro,
          "codigo_barras": item.codBa2,
          "derivacao": item.codDer ? item.codDer.substring(0, 6) : '',
          "quantidade": item.qtdPro,
          "preco_anterior": Number(item.maiPvn).toFixed(2).replace('.', ','),
          "novo_preco": Number(item.preVen).toFixed(2).replace('.', ','),
          "cor": item.desCor ? item.desCor.substring(0, 15) : '',
          "codigo_pai_senior": item.codPai ? item.codPai: '',
          "marca": item.desCcp ? item.desCcp.substring(0, 15) : '',
          "familia": item.desFam ? item.desFam.substring(0, 18) : '',
          "descricao_produto": item.desPro ? item.desPro.substring(0, 20) : '',
          "intervalo_derivacao": item.intDer ? item.intDer.substring(0, 12) : '',
          "faixa_preco": item.fxaPre ? item.fxaPre.substring(0, 5) : '',
          "preco":Number(item.preVen).toFixed(2).replace('.', ','),
          "noos": item.noos ? item.noos: '',
          "piramide_produto": item.pirPro ? item.pirPro.substring(0, 10) : '',
          "ultima_data": item.ultDat,
          "tema": item.desTem ? item.desTem.substring(0, 10) : '',
          "exposicao": item.desExp ? item.desExp.substring(0, 10) : '',
          "qrcode": item.qrcode
        }));
        const pesquisaPayload = {
          "dados": dadosParaImpressao,
          "id_modelo_etiqueta": modeloSelecionado.value.value,
          "id_modelo_impressora": idModeloImpressora.value, 
          "qtd_repetir": qtdRepetir.value
        };

        const { layout } = await EtiquetasServices.pesquisarEtiqueta(pesquisaPayload);
        await ImpressaoServices.imprimirEtiqueta(layout, nomeModeloImpressora.value, nomeComputadorImpressora.value);

        exibirMensagem("Etiqueta(s) enviada(s) para impressão com sucesso.", 'positive');
      } catch (error) {
        exibirMensagem("Erro ao enviar etiquetas para impressão: " + error);
      } finally {
        $q.loading.hide();
      }
    };


    return {
      codBarras,
      codProduto,
      nrEmbalagem,
      dados,
      colunas,
      subColumns,
      sanitizeInput,
      buscar,
      imprimir,
      exibirMensagem,
      modelosEtiquetas,
      modeloSelecionado,
      idModeloImpressora,
      nomeModeloImpressora,
      nomeComputadorImpressora,
      qtdRepetir,
      buscaRealizada,
      sanitizeqtdRepetir,
      handleKeyDown
    };
  },
};
</script>

<style>
.bg-white {
  background-color: white;
}

.rounded-borders {
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.custom-table {
  color: var(--q-primary-text-color);
}

.q-table__bottom {
  display: none;
}

.custom-table .q-table__grid td {
  border-color: var(--q-input-border-color);
}

.custom-subtable .bg-light {
  background-color: #e9ecef;
}

.custom-subtable {
  background-color: #f8f9fa;
  font-size: 1.5em;
}

.custom-header {
  font-weight: bold;
  font-size: 2em;
}
</style>
